(function ($) {
  $(document).ready(function () {
    stickyHeader();

    $(window).scroll(function () {
      stickyHeader();
    });

    $("body").addClass("js");

    var rellax = new Rellax(".rellax", {
      center: true,
      breakpoints: [768, 980, 1080],
    });


    $(".horizontal-cards-slider").slick({
      autoplay: false,
      speed: 300,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: true,
      draggable: true,
    });


    $(".testimonials__slider").slick({
      autoplay: false,
      speed: 300,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: true,
      draggable: true,
    });

    // Initialize testimonials slider
    $(".icon-features-carousel--1 .icon-features__items").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1264,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            slidesToScroll: 1
          }
        }]
    });

    var slider = $(".image-features__items");

    enquire.register("screen and (max-width: 1079px)", {
      match: function () {
        if (!slider.hasClass("slick-initialized")) {
          slider.slick({
            autoplay: false,
            speed: 300,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
          });
        }
      },
      unmatch: function () {
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
      },
    });
  });

  // Sticky header
  var stickyHeaderTop = $(".js-header").offset().top;
  var stickyHeader = function () {
    var scrollTop = $(window).scrollTop();

    if (scrollTop > stickyHeaderTop) {
      $(".js-header").addClass("sticky");
    } else {
      $(".js-header").removeClass("sticky");
    }
  };

  // Product select
  var $productSelect = $('.product-select a');
  $productSelect.click(function(e) {
    $productSelect.removeClass('active');
    $(this).addClass('active');

    var cat = $(this).data('show');
    $('.product-cards .product').hide();
    $('.product-cards .product.' + cat).show();
    e.preventDefault();
  });
  $('.product-select a:first').click();

  // Counters
  // if ($('.counter-up--enabled-1').length > 0) {
  //   $(".counter-up--enabled-1 .counter-up__number").counterUp({
  //     delay: 30,
  //     time: 2000,
  //     offset: 75,
  //     beginAt: 0,
  //   });
  // }

  var $headerSearchToggle = $(".header-search-btn"),
    $headerSearchWrap = $(".header-search-wrapper"),
    $headerSearchInput = $headerSearchWrap.find('input[type="search"]');

  // Handler for click show/hide button.
  $headerSearchToggle.on("click", function (event) {
    event.preventDefault();

    if ($(this).hasClass("open")) {
      hideSearch();
    } else {
      showSearch();
    }
  });

  // Handler for pressing show/hide button.
  $headerSearchToggle.on("keydown", function (event) {
    // If tabbing from toggle button, and search is hidden, exit early.
    if (9 === event.keyCode && !$headerSearchWrap.hasClass("search-visible")) {
      return;
    }

    event.preventDefault();
    handleKeyDown(event);
  });

  // Hide search when tabbing or escaping out of the search bar.
  $headerSearchInput.on("keydown", function (event) {
    // Tab: 9, Esc: 27.
    if (9 === event.keyCode || 27 === event.keyCode) {
      hideSearch(event.target);
    }
  });

  $('.accordion h2').on('click', function() {
    $(this).parent().toggleClass('expanded');
  });

  $('.layout-row.modal').click(function(e) {
    if (e.offsetX < 0 || e.offsetX > ($(this).innerWidth() - 30) ||
        e.offsetY < 0 || e.offsetY > ($(this).innerHeight() - 30)) {
      $('.layout-row.modal').fadeOut(200);
      $('.dim-content').remove();
    }
  }).fadeIn(200);

  if ($('.node-page-layout-builder-form').length == 0) {
    $('.modal--dim-content').not('.layout-builder__layout').wrap('<div class="dim-content"></div>');
  }

  // Helper function to show the search form.
  function showSearch() {
    $headerSearchToggle.addClass("open").attr("aria-expanded", true);
    $headerSearchWrap.addClass("search-visible").fadeIn("fast");
    $headerSearchInput.focus();
  }

  // Helper function to hide the search form.
  function hideSearch() {
    $headerSearchToggle.removeClass("open").attr("aria-expanded", false);
    $headerSearchWrap.removeClass("search-visible").fadeOut("fast");
  }

  // Keydown handler function for toggling search field visibility.
  function handleKeyDown(event) {
    // Enter/Space, respectively.
    if (13 === event.keyCode || 32 === event.keyCode) {
      event.preventDefault();

      if ($(event.target).hasClass("open")) {
        hideSearch();
      } else {
        showSearch();
      }
    }
  }
})(jQuery);
